var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.852 6.323 13.7 9.218l2.638-2.498 2.452 2.498 2.895-2.895L16.175 1l-5.323 5.323z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.42 10.128 22.035 6.72l-5.813 5.743-5.813-5.743-3.41 3.408 5.837 5.79L7 21.708l3.502 3.455 5.743-5.766 5.767 5.766 3.478-3.455-5.72-5.79 5.65-5.79z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m16.245 25.163-2.451-2.52-2.918 2.94L16.245 31l5.439-5.416-2.895-2.942-2.545 2.521z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdx);
export default __webpack_public_path__ + "static/media/ADX.98934c5763103ba7df9ccedaac3db0b1.svg";
export { ForwardRef as ReactComponent };